<div id="vvpm-activity" class="timeline-card-container" (contextmenu)="onContextMenu($event)">
  <div class="timeline-card" data-testid="card" (click)="onCardClick()">
    <!-- Icon Column with Orange color -->
    <div class="card-icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 192 192">
        <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"
              d="M101.74 165.77a70.06 70.06 0 0 0 61.67-88.71M32.51 66.48a70.05 70.05 0 0 0 46.56 97.45M153.74 56.41A70 70 0 0 0 45.43 47.6"
              [style.stroke]="'var(--vvpm-secondary-color)'"/>
        <path fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="8"
              d="M158.18 35.11L155.1 57H133M12.18 72.59l20.49-8.28 11.06 19.15M117.64 180.3l-17.42-13.61 11.06-19.15"
              [style.stroke]="'var(--vvpm-primary-color)'"/>
      </svg>
    </div>
    
    <!-- Content Column -->
    <div class="card-content">
      <!-- Status Tag (Always at top-right) -->
      <div class="status-container">
        @if(vvpmActivity.display_status) {
          <span class="status-tag"
                [class.status-in-progress]="vvpmActivity.display_status === 'In Progress'"
                [class.status-published]="vvpmActivity.display_status === 'Published'"
                [class.status-rejected]="vvpmActivity.display_status === 'Rejected'"
                [class.status-submitted]="vvpmActivity.display_status === 'Submitted'"
                [class.status-accepted]="vvpmActivity.display_status === 'Accepted'"
                [class.status-approved]="vvpmActivity.display_status === 'Approved'"
                [class.status-planned]="vvpmActivity.display_status === 'Planned'"
                [class.status-planning]="vvpmActivity.display_status === 'Planning'">
            {{ vvpmActivity.display_status }}
          </span>
        }
        @if(vvpmActivity.isVisible == false) {
          <span class="hidden-indicator" title="Hidden">
            <rds-icon namespace="filled" icon="visibility_off"></rds-icon>
          </span>
        }
      </div>
      
      <!-- Title (Primary element) -->
      <h3 class="card-title" data-testid="name">{{ vvpmActivity.name__v }}</h3>
      
      <!-- Flexible Tag Area (Strategic Pillars & Veeva Audiences) -->
      <div class="tags-container">
        <!-- Strategic Pillars (manually tagged) -->
        @if (vvpmActivity.strategicPillars && vvpmActivity.strategicPillars.length > 0) {
          @for (sp of vvpmActivity.strategicPillars; track sp) {
            <span class="strategic-pillar-tag" 
                  [style.background-color]="sp.color_code"
                  [style.color]="getContrastColor(sp.color_code)"
                  [title]="'Strategic Pillar: ' + sp.title">
              {{ sp.title }}
            </span>
          }
        }
        
        <!-- Veeva Audiences (read-only from Veeva PromoMats) -->
        @if (getCombinedAudiences().length > 0) {
          @for (audience of getCombinedAudiences(); track audience) {
            <span class="veeva-audience-tag"
                  title="Audience (from Veeva): {{ audience }}">
              {{ audience }}
            </span>
          }
        }
      </div>
      
      <!-- Document Number -->
      <div class="document-info">
        <span class="document-number">{{ vvpmActivity.document_number__v }}</span>
      </div>
    </div>
  </div>
</div>
